import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, DefaultValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HappyInputBase } from '../happy-template-input/happy-input-base';

export const TEXTAREA_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HappyTextareaInputComponent),
    multi: true,
};

@Component({
    selector: 'happy-textarea-input',
    templateUrl: './happy-textarea-input.component.html',
    styleUrls: ['./happy-textarea-input.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
    providers: [TEXTAREA_INPUT_VALUE_ACCESSOR]
})
export class HappyTextareaInputComponent extends HappyInputBase {

    @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;

    @Input() placeholder: string;

    constructor(parentForm: FormGroupDirective) {
        super(parentForm);
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    writeValue(obj: any) {
        this.valueAccessor.writeValue(obj);
    }

    registerOnChange(fn: any) {
        this.valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any) {
        this.valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean) {
        this.valueAccessor.setDisabledState(isDisabled);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-textarea-input/happy-textarea-input.component.ts